import { c as _c } from "react/compiler-runtime";
import React, { useState, useContext } from 'react';
import { MdClose } from 'react-icons/md';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClipLoader } from 'react-spinners';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslations } from 'next-intl';
import { amplitudeInstance } from '../../config/amplitude';
import NativeSelect from '../NativeSelect';
import AuthContext from '../../context/AuthContext';
import isStringEmpty from '../../helpers/isStringEmpty';
import api from '../../services/api';
import { UserList } from '../../types/types';
interface PropTypes {
  isOpen: boolean;
  onClose: () => void;
  data: UserList;
}
function EditListModal(t0) {
  const $ = _c(102);
  const {
    isOpen,
    onClose,
    data
  } = t0;
  const queryClient = useQueryClient();
  const auth = useContext(AuthContext);
  const t = useTranslations();
  const [listNameInput, setListNameInput] = useState(data.name);
  const [listDescriptionInput, setListDescriptionInput] = useState(data.description || "");
  const [selectedPrivacyInput, setSelectedPrivacyInput] = useState(data.privacy);
  let t1;
  if ($[0] !== auth || $[1] !== onClose || $[2] !== queryClient) {
    t1 = {
      mutationFn: _temp,
      onSuccess: (t2, t3) => {
        const {
          data: data_1
        } = t2;
        const {
          listId: listId_0
        } = t3;
        setSelectedPrivacyInput(data_1.privacy);
        queryClient.setQueryData([`lists-${listId_0}`], () => ({
          data: data_1
        }));
        if (queryClient.getQueryData(["me-lists-with-pagination"])) {
          queryClient.setQueryData(["me-lists-with-pagination"], old => {
            const pages = old.pages.map(page => ({
              ...page,
              data: page.data.map(list => {
                if (list._id === listId_0) {
                  return data_1;
                }
                return list;
              })
            }));
            return {
              pages,
              pageParams: old.pageParams
            };
          });
        }
        if (queryClient.getQueryData([`users-${auth.userData?._id}`])) {
          queryClient.setQueryData([`users-${auth.userData?._id}`], old_0 => ({
            data: {
              ...old_0.data,
              lists: old_0.data.lists.map(list_0 => {
                if (list_0._id === listId_0) {
                  return data_1;
                }
                return list_0;
              })
            }
          }));
        }
        onClose();
        queryClient.invalidateQueries({
          queryKey: [`lists-${listId_0}`]
        });
        queryClient.invalidateQueries({
          queryKey: ["me-lists-with-pagination"]
        });
        queryClient.invalidateQueries({
          queryKey: [`users-${auth.userData?._id}`]
        });
      }
    };
    $[0] = auth;
    $[1] = onClose;
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateListMutation = useMutation(t1);
  let t2;
  if ($[4] !== data._id || $[5] !== data.privacy || $[6] !== onClose) {
    t2 = isOpen_0 => {
      if (!isOpen_0) {
        amplitudeInstance.logEvent("Close Update List Modal", {
          list_id: data._id,
          list_privacy: data.privacy
        });
        onClose();
      }
    };
    $[4] = data._id;
    $[5] = data.privacy;
    $[6] = onClose;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("modals.edit_list.title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <span className="text-white font-bold text-2xl">{t3}</span>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MdClose size="28" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClose) {
    t6 = <button className="text-white" onClick={onClose}>{t5}</button>;
    $[13] = onClose;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="flex flex-row justify-between items-center">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("modals.edit_list.inputs.list_name.label");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <label htmlFor="name" className="text-white">{t8}</label>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("modals.edit_list.inputs.list_name.placeholder");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setListNameInput(e.target.value);
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== listNameInput || $[26] !== t10) {
    t12 = <input className="h-[40px] rounded-md bg-black text-white placeholder:text-gray-200 p-4 mt-2" id="name" placeholder={t10} value={listNameInput} onChange={t11} />;
    $[25] = listNameInput;
    $[26] = t10;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t9) {
    t13 = <div className="flex flex-col">{t9}{t12}</div>;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("modals.edit_list.inputs.list_description.label");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <label htmlFor="description" className="text-white">{t14}</label>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("modals.edit_list.inputs.list_description.placeholder");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => setListDescriptionInput(e_0.target.value);
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== listDescriptionInput || $[39] !== t16) {
    t18 = <input className="h-[40px] rounded-md bg-black text-white placeholder:text-gray-200 p-4 mt-2" id="description" placeholder={t16} value={listDescriptionInput} onChange={t17} />;
    $[38] = listDescriptionInput;
    $[39] = t16;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t15 || $[42] !== t18) {
    t19 = <div className="flex flex-col">{t15}{t18}</div>;
    $[41] = t15;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t) {
    t20 = t("modals.edit_list.inputs.privacy.label");
    $[44] = t;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t20) {
    t21 = <label htmlFor="privacy" className="text-white">{t20}</label>;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_1 => setSelectedPrivacyInput(e_1.target.value);
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("user_list_privacy.public");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23) {
    t24 = <option value="public">{t23}</option>;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t) {
    t25 = t("user_list_privacy.private");
    $[53] = t;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t25) {
    t26 = <option value="private">{t25}</option>;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== selectedPrivacyInput || $[58] !== t24 || $[59] !== t26) {
    t27 = <NativeSelect id="privacy" containerClassName="mt-2" className="h-[40px] rounded-md border-[1px] border-gray-200 bg-black px-4 text-white" value={selectedPrivacyInput} onChange={t22}>{t24}{t26}</NativeSelect>;
    $[57] = selectedPrivacyInput;
    $[58] = t24;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t21 || $[62] !== t27) {
    t28 = <div className="flex flex-col">{t21}{t27}</div>;
    $[61] = t21;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t13 || $[65] !== t19 || $[66] !== t28) {
    t29 = <div className="flex flex-col mt-4 gap-y-4">{t13}{t19}{t28}</div>;
    $[64] = t13;
    $[65] = t19;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== data._id || $[69] !== data.privacy || $[70] !== onClose) {
    t30 = () => {
      setListNameInput("");
      setSelectedPrivacyInput("private");
      amplitudeInstance.logEvent("Close Update List Modal", {
        list_id: data._id,
        list_privacy: data.privacy
      });
      onClose();
    };
    $[68] = data._id;
    $[69] = data.privacy;
    $[70] = onClose;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t) {
    t31 = t("modals.edit_list.cancel");
    $[72] = t;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t30 || $[75] !== t31) {
    t32 = <button onClick={t30} className="h-[40px] bg-white hover:bg-gray-100 text-black rounded-md px-4 font-bold mr-2">{t31}</button>;
    $[74] = t30;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== data._id || $[78] !== listDescriptionInput || $[79] !== listNameInput || $[80] !== selectedPrivacyInput || $[81] !== updateListMutation) {
    t33 = () => {
      if (!updateListMutation.isPending) {
        amplitudeInstance.logEvent("Update List", {
          list_id: data._id,
          list_updated_privacy: selectedPrivacyInput
        });
        updateListMutation.mutate({
          listId: data._id,
          data: {
            name: listNameInput,
            description: listDescriptionInput,
            privacy: selectedPrivacyInput
          }
        });
      }
    };
    $[77] = data._id;
    $[78] = listDescriptionInput;
    $[79] = listNameInput;
    $[80] = selectedPrivacyInput;
    $[81] = updateListMutation;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== t) {
    t34 = t("modals.edit_list.save");
    $[83] = t;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== updateListMutation.isPending) {
    t35 = updateListMutation.isPending && <ClipLoader className="ml-2" color="white" size={18} />;
    $[85] = updateListMutation.isPending;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t33 || $[88] !== t34 || $[89] !== t35) {
    t36 = <button onClick={t33} className="flex flex-row items-center justify-center h-[40px] bg-red-600 hover:bg-red-500 text-white rounded-md px-4 font-bold">{t34}{t35}</button>;
    $[87] = t33;
    $[88] = t34;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  let t37;
  if ($[91] !== t32 || $[92] !== t36) {
    t37 = <div className="flex flex-row justify-end mt-4">{t32}{t36}</div>;
    $[91] = t32;
    $[92] = t36;
    $[93] = t37;
  } else {
    t37 = $[93];
  }
  let t38;
  if ($[94] !== t29 || $[95] !== t37 || $[96] !== t7) {
    t38 = <Dialog.Portal><Dialog.Overlay className="flex justify-center items-center fixed inset-0 bg-[rgba(0,0,0,0.7)] bg-opacity-25 transition-opacity z-10 px-2"><Dialog.Content className="w-full md:w-[500px] bg-gray-600 rounded-md p-4">{t7}{t29}{t37}</Dialog.Content></Dialog.Overlay></Dialog.Portal>;
    $[94] = t29;
    $[95] = t37;
    $[96] = t7;
    $[97] = t38;
  } else {
    t38 = $[97];
  }
  let t39;
  if ($[98] !== isOpen || $[99] !== t2 || $[100] !== t38) {
    t39 = <Dialog.Root open={isOpen} onOpenChange={t2}>{t38}</Dialog.Root>;
    $[98] = isOpen;
    $[99] = t2;
    $[100] = t38;
    $[101] = t39;
  } else {
    t39 = $[101];
  }
  return t39;
}
async function _temp(t0) {
  const {
    listId,
    data: data_0
  } = t0;
  const response = await api.put(`/v1/me/lists/${listId}/`, {
    name: data_0.name,
    description: !isStringEmpty(data_0.description) ? data_0.description : null,
    privacy: data_0.privacy
  });
  return response.data;
}
export default EditListModal;